const adB2CHost = "saguitechb2c.b2clogin.com";
const tenant = "saguitechb2c.onmicrosoft.com";

export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1_SIGNUP_SIGNIN",
    editProfile: "B2C_1_EDIT"
  },
  authorities: {
    signUpSignIn: {
      authority: 'https://' + adB2CHost + '/' + tenant + '/' + 'B2C_1_SIGNUP_SIGNIN',
    },
    editProfile: {
      authority: 'https://' + adB2CHost + '/' + tenant + '/' + 'B2C_1_EDIT'
    },
    resetPassword: {
      authority: 'https://' + adB2CHost + '/' + tenant + '/' + 'B2C_1_PASSWORD'
    },
    signUp: {
      authority: 'https://' + adB2CHost + '/' + tenant + '/' + 'B2C_1_SIGNUP'
    },
    signIn: {
      authority: 'https://' + adB2CHost + '/' + tenant + '/' + 'B2C_1_SIGNIN'
    }
  },
  authorityDomain: adB2CHost
}

